import { cn } from "./utils";
import * as PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { LuArrowLeft, LuArrowRight } from "react-icons/lu";

export default function Pagination(props) {
  const { defaultValue = 0, pageCount = 0, onPageIndexChange, disabled, prevBtn, nextBtn, className } = props;
  const [value, setValue] = useState(((defaultValue ?? 0) + 1).toString());
  const [pageIndex, setPageIndex] = useState(defaultValue);

  useEffect(() => {
    setValue(((defaultValue ?? 0) + 1).toString());
    setPageIndex(defaultValue);
  }, [defaultValue]);

  useEffect(() => {
    onPageIndexChange?.(pageIndex);
  }, [pageIndex]);

  function handlePagination(index) {
    setValue(index + 1);
    console.log(">>", index, pageCount);
    if (index > pageCount - 1 || index < 0) return;
    setPageIndex(index);
  }
  useEffect(() => {
    function handleKeys({ keyCode }) {
      if (keyCode === 37 && pageIndex > 0) handlePagination(pageIndex - 1);
      if (keyCode === 39 && pageIndex < pageCount - 1) handlePagination(pageIndex + 1);
    }
    window.addEventListener("keydown", handleKeys);
    return () => window.removeEventListener("keydown", handleKeys);
  }, [pageIndex]);

  return (
    <div
      style={{ pointerEvents: disabled ? "none" : "auto" }}
      className={cn(
        "flex items-center justify-between px-[10px] py-[6px] bg-[#fff]  border-t border-t-solid border-t-[#eaecf0] sticky bottom-0",
        className
      )}
    >
      
      <div
        style={{ opacity: pageIndex <= 0 ? 0.5 : 1, pointerEvents: pageIndex <= 0 ? "none" : "auto", cursor: "pointer" }}
        onClick={() => handlePagination(pageIndex - 1)}
      >
        {prevBtn || (
          <button
            // disabled={pageIndex <= 0}
            className="disabled:opacity-30 w-[121px] flex gap-[8px] items-center justify-center px-[10px] py-[8px] border border-solid border-[#d0d5dd] rounded-[8px] select-none cursor-pointer hover:bg-[#d0d5dd]"
          >
            <LuArrowLeft />
            <div className="text-[16px] text-[#344054] font-semibold">Previous</div>
          </button>
        )}
      </div>

      {/* Pagination */}
      <div className="flex gap-2 items-center text-[12px] md:text-[14px] font-semibold text-[#667085]">
  <input
    type="number"
    value={value}
    onChange={(e) => {
      setValue(e.target.value);
      const index = e.target.value ? Number(e.target.value) - 1 : 0;
      setPageIndex(+index.toFixed());
    }}
    onBlur={(e) => (e.target.value = pageIndex + 1)}
    style={{
      width: "30px",
      padding: "2px",
      color: "#224b99",
      backgroundColor: "#f9fafb",
      boxShadow: "0 0 2px 0 rgba(0, 0, 0, 0.1)",
      borderRadius: "8px",
      transition: "background-color 0.2s ease-in-out",
    }}  />
  &nbsp; /&nbsp;{pageCount}
</div>


      {/* Next Button */}
      <div
        style={{
          opacity: pageIndex >= pageCount - 1 ? 0.5 : 1,
          pointerEvents: pageIndex >= pageCount - 1 ? "none" : "auto",
          cursor: "pointer",
        }}
        onClick={() => handlePagination(pageIndex + 1)}
      >
        {nextBtn || (
          <button
            // disabled={pageIndex >= pageCount - 1}
            className="disabled:opacity-30 w-[121px] flex gap-[8px] items-center justify-center px-[10px] py-[8px] border border-solid border-[#d0d5dd] rounded-[8px] select-none cursor-pointer hover:bg-[#d0d5dd]"
          >
            <div className="text-[16px] text-[#344054] font-semibold">Next</div>
            <LuArrowRight />
          </button>
        )}
      </div>
    </div>
  );
}

Pagination.propTypes = {
  defaultValue: PropTypes.number,
  className: PropTypes.string,
  pageCount: PropTypes.number,
  onPageIndexChange: PropTypes.func,
  disabled: PropTypes.bool,
  prevBtn: PropTypes.node,
  nextBtn: PropTypes.node,
};
